var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPride = function SvgPride(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.82959,
    y: 3.59857,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 1.82959 3.59857)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.07593,
    y: 5.58334,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 2.07593 5.58334)",
    fill: "#7A4F2F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.32227,
    y: 7.56812,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 2.32227 7.56812)",
    fill: "#CB1C1C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.56873,
    y: 9.55289,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 2.56873 9.55289)",
    fill: "#EB8B33"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.81506,
    y: 11.5376,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 2.81506 11.5376)",
    fill: "#EBC233"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.0614,
    y: 13.5224,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 3.0614 13.5224)",
    fill: "#6BBB2C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30774,
    y: 15.5072,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 3.30774 15.5072)",
    fill: "#3E7EDE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5542,
    y: 17.4919,
    width: 28,
    height: 2,
    transform: "rotate(-7.07587 3.5542 17.4919)",
    fill: "#8433EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.741 7.33522C1.15849 5.539 1.11256 4.00747 0.837158 3.72174L2.01421 3.57563C2.50095 4.08062 3.14853 5.23323 3.74935 7.08592C4.35886 8.96541 4.94039 11.628 5.2515 15.2166C5.8649 22.2921 6.74817 28.1606 7.11067 30.198L5.34601 30.4171C4.97646 28.3401 3.6399 22.6071 3.02317 15.4932C2.71921 11.987 2.77368 11.8655 1.741 7.33522Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPride, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pride.ec75fad6.svg";
export { ForwardRef as ReactComponent };